<template>
  <ContentBox title="New User Group">
    <template v-slot:content>
      <FormGroup v-bind:form="userGroupForm">
        <FormRow label="Name"><FormInputText v-model="userGroup.name" field="name" /></FormRow>
        <FormRow label="Colour"><FormColourTag v-model="userGroup.colourTag" field="colourTag" /></FormRow>
        <FormRow label="Users"><FormMultiSelect :value="userGroupMembership" @input="userGroupMembership = $event" :options="userList" :loading="userListLoading" placeholder="Select Users" /></FormRow>

        <FormSubmit label="Create" :submitting="submitting" @submitted="createUserGroup" @cancelled="cancelCreateUserGroup" />
      </FormGroup>
    </template>
  </ContentBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import { PersonTitleLookup } from '@/store/types'

export default {
  name: "UserGroupNew",
  mixins: [form],
  components: {
  },
  data: () => {
    return {
      breadcrumbs: [
        { title: "Users", link: "/users" },
        { title: "User Groups" }
      ],
      userGroup: { },
      userGroupForm: {},
      submitting: false,
      userGroupMembership: [],
      userList: [],
      userListLoading: false
    };
  },
  mounted() {
    // Get User list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.userListLoading = true
    this.$apiService.userService.getUserList()
    .then(list => {
      this.userList = list.data.map(userInfo => {
        return {
          value: userInfo.id,
          name: userInfo.name
        }
      })
      this.userListLoading = false
    })
  },
  methods: {
    createUserGroup() {
      this.submitting = true

      var userGroupData = _.cloneDeep(this.$data.userGroup)
      this.$data.userGroupForm = this.clearFormResponse()

      // Only update certain fields
      var updateData = _.pick(userGroupData, ['name', 'colourTag', 'users'])
      updateData.users = this.userGroupMembership

      this.$apiService.userService.createUserGroup(updateData)
        .then((response) => {
          this.submitting = false
          this.successToast('User Group Created')
          this.$router.push(`/users/groups/${response.data.id}`)
        })
        .catch(err => {
          this.submitting = false
          this.$data.userGroupForm = this.processFormResponse(err)
        })
    },
    cancelCreateUserGroup() {
      this.$router.push('/users/groups')
    }
  }
}

</script>